// Global CSS classes
enum GlobalClass {
  ButtonPlain = "buttonPlain",
  CardAnimation = "cardAnimation",
  CardAnimationNoTransform = "cardAnimationNoTransform",
  DelayedSpinner = "delayedSpinner",
  GradientText = "gradientText",
  HideScrollbar = "hideScrollbar",
  HideText = "hideText",
  ThinScrollbar = "thinScrollbar",
}

export default GlobalClass;
